import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import RoomsPage from "@/pages/RoomsPage";
import RoomDetailPage from "@/pages/RoomDetailPage";
import CommunityPage from "@/pages/CommunityPage";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";

import TenantDashboard from "@/pages/tenant/TenantDashboard";
import TenantApplicationPage from "@/pages/tenant/TenantApplicationPage";
import TenantMaintenancePage from "@/pages/tenant/TenantMaintenancePage";
import TenantPaymentsPage from "@/pages/tenant/TenantPaymentsPage";
import TenantLeasesPage from "@/pages/tenant/TenantLeasesPage";
import TenantDocumentsPage from "@/pages/tenant/TenantDocumentsPage";
import PaymentCompletePage from "@/pages/tenant/PaymentCompletePage";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRoomsPage from "@/pages/admin/AdminRoomsPage";
import AdminApplicationsPage from "@/pages/admin/AdminApplicationsPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminMaintenancePage from "@/pages/admin/AdminMaintenancePage";
import AdminLeasesPage from "@/pages/admin/AdminLeasesPage";
import AdminDocumentsPage from "@/pages/admin/AdminDocumentsPage";
import AdminReportsPage from "@/pages/admin/AdminReportsPage";

import SystemAdminDashboard from "@/pages/system/SystemAdminDashboard";
import FinanceDashboard from "@/pages/finance/FinanceDashboard";
import PropertyManagementDashboard from "@/pages/property/PropertyManagementDashboard";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/rooms/:id" element={<RoomDetailPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          <Route path="/tenant" element={<ProtectedRoute><TenantDashboard /></ProtectedRoute>} />
          <Route path="/tenant/apply" element={<ProtectedRoute><TenantApplicationPage /></ProtectedRoute>} />
          <Route path="/tenant/apply/:roomId" element={<ProtectedRoute><TenantApplicationPage /></ProtectedRoute>} />
          <Route path="/tenant/maintenance" element={<ProtectedRoute><TenantMaintenancePage /></ProtectedRoute>} />
          <Route path="/tenant/payments" element={<ProtectedRoute><TenantPaymentsPage /></ProtectedRoute>} />
          <Route path="/tenant/leases" element={<ProtectedRoute><TenantLeasesPage /></ProtectedRoute>} />
          <Route path="/tenant/documents" element={<ProtectedRoute><TenantDocumentsPage /></ProtectedRoute>} />
          <Route path="/payment/complete" element={<ProtectedRoute><PaymentCompletePage /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/rooms" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminRoomsPage /></ProtectedRoute>} />
          <Route path="/admin/applications" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminApplicationsPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/admin/maintenance" element={<ProtectedRoute roles={["admin","super_admin","operations"]}><AdminMaintenancePage /></ProtectedRoute>} />
          <Route path="/admin/leases" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminLeasesPage /></ProtectedRoute>} />
          <Route path="/admin/documents" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminDocumentsPage /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute roles={["admin","super_admin"]}><AdminReportsPage /></ProtectedRoute>} />

          <Route path="/system-admin" element={<ProtectedRoute roles={["super_admin"]}><SystemAdminDashboard /></ProtectedRoute>} />
          <Route path="/finance" element={<ProtectedRoute roles={["finance","admin","super_admin"]}><FinanceDashboard /></ProtectedRoute>} />
          <Route path="/property" element={<ProtectedRoute roles={["operations","admin","super_admin"]}><PropertyManagementDashboard /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
